import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { PortalAppBatchExportComponent } from "./portal-app-batch-export/portal-app-batch-export.component";
import { PortalAppBatchImportTableComponent } from "./portal-app-batch-import-table/portal-app-batch-import-table.component";
import { PortalAppBatchImportComponent } from "./portal-app-batch-import/portal-app-batch-import.component";
import { DataService_PortalAppBatchRegistration } from "./shared/data.service";
import { PABatchEmailRequest } from "./shared/pa-batch-email-request";

@Component({
	selector: "caass-portal-app-batch-registration",
	templateUrl: "./portal-app-batch-registration.component.html",
	styleUrls: ["./portal-app-batch-registration.component.css"],
})
export class PortalAppBatchRegistrationComponent implements OnInit {
	constructor(
		private dialogService: DialogService,
		private dataService: DataService_PortalAppBatchRegistration,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////

	TableLoading: boolean = false;
	Processing: boolean = false;

	ErrorMessage: string = "";

	@ViewChild(PortalAppBatchImportTableComponent)
	tableRef: PortalAppBatchImportTableComponent;

	AppTypeID: number = -1;

	ImportPreviewExpand: boolean = false;
	// EmailLogExpand: boolean = false;

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////

	loadImportTableData(parms) {
		this.TableLoading = true;

		var result = this.dataService.PortalAppImportDataSelectList(parms);
		result.subscribe(
			(response) => {
				this.tableRef.UpdateData(response);
				this.ImportPreviewExpand = true;
				// this.EmailLogExpand = false;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////

	onImport() {
		this.ErrorMessage = "";

		var ref = this.dialogService.open(PortalAppBatchImportComponent, {
			header: "Import",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response: any) => {
			if (response != 0) {
				this.AppTypeID = response.AppTypeID;
				this.loadImportTableData(response);
			}
		});
	}

	onRemoveSelected() {
		this.ErrorMessage = "";

		this.tableRef.RemoveSelected();
	}

	onRemoveInvalid() {
		this.ErrorMessage = "";

		this.tableRef.RemoveInvalid();
	}

	onClearImport() {
		this.ErrorMessage = "";

		this.tableRef.UpdateData([]);
	}

	onDownloadImport() {
		this.ErrorMessage = "";

		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"ID",`;
		DataStr += `"First Name",`;
		DataStr += `"Last Name",`;
		DataStr += `"School Name",`;
		DataStr += `"Active",`;
		DataStr += `"Email",`;
		DataStr += `"App",`;
		DataStr += `"Valid Entry",`;
		DataStr += "\n";

		for (var z = 0; z < this.tableRef.lstPerson.length; z++) {
			var next = this.tableRef.lstPerson[z];

			DataStr += `"` + next.ID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.SchoolFullName + `",`;
			DataStr += `"` + next.ActiveDesc + `",`;
			DataStr += `"` + next.Email + `",`;
			DataStr += `"` + next.AppDesc + `",`;
			DataStr += `"` + next.ValidEntryDesc + `",`;
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>
		var FileName = "PortalAppImportedData";

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	onExport() {
		this.ErrorMessage = "";

		var ref = this.dialogService.open(PortalAppBatchExportComponent, {
			header: "Export",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response: any) => {});
	}

	onBatchEmail() {
		this.ErrorMessage = "";

		//
		// Error Handling
		//

		var lstID: number[] = [];
		var lstEmail: string[] = [];

		var NoEmailCount = 0;
		var InvalidCount = 0;
		var ValidCount = 0;

		for (var z = 0; z < this.tableRef.lstPerson.length; z++) {
			var next = this.tableRef.lstPerson[z];

			if (next.ValidEntry == 1) {
				if (String(next.Email).trim() != "") {
					lstID = [...lstID, next.PersonID];
					lstEmail = [...lstEmail, next.Email];

					ValidCount++;
				} else {
					NoEmailCount++;
				}
			} else {
				InvalidCount++;
			}
		}

		console.log("Invalid");
		console.log(InvalidCount);

		console.log("No Email");
		console.log(NoEmailCount);

		if (ValidCount == 0) {
			this.ErrorMessage = "Import data and fill in the email addresses if necessary.";

			if (InvalidCount > 0) {
				this.ErrorMessage +=
					" " +
					InvalidCount +
					" " +
					(InvalidCount == 1 ? "Entry" : "Entries") +
					" " +
					(InvalidCount == 1 ? "is" : "are") +
					" invalid (Check the Student or Staff ID).";
			}
			if (NoEmailCount > 0) {
				this.ErrorMessage +=
					" " +
					NoEmailCount +
					" " +
					(NoEmailCount == 1 ? "Entry" : "Entries") +
					" " +
					(NoEmailCount == 1 ? "doesn't" : "don't") +
					" have an email filled in.";
			}

			return;
		}

		var Msg = "You are about to send " + ValidCount + " registration emails.";

		if (NoEmailCount > 0) {
			Msg += " Skipping " + NoEmailCount + " entr" + (NoEmailCount == 1 ? "y" : "ies") + " with NO EMAIL filled in.";
		}
		if (InvalidCount > 0) {
			Msg += " Skipping " + InvalidCount + " invalid entr" + (InvalidCount == 1 ? "y" : "ies");
		}

		Msg += " Do you want to continue?";

		this.confirmationService.confirm({
			key: "portalappimportconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Success",
			icon: "fa",
			accept: () => {
				this.FinishBatchEmail(lstID, lstEmail);
			},
		});
	}

	FinishBatchEmail(lstID: number[], lstEmail: string[]) {
		this.Processing = true;

		var parms: PABatchEmailRequest = {
			AppTypeID: this.AppTypeID,
			lstID: lstID,
			lstEmail: lstEmail,
		};

		console.log(parms);

		var result = this.dataService.PortalAppBatchEmail(parms);
		result.subscribe(
			(response) => {
				this.ImportPreviewExpand = false;
				// this.EmailLogExpand = true;

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////
}
